// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SCXIIHF6ax3bOJ {
  max-width: 572px;
  margin: var(--ds-space-0, 0) auto;
  margin-top: var(--ds-space-600, 48px);
  padding: var(--ds-space-0, 0) var(--ds-space-200, 16px);
  text-align: center;
}
@media only screen and (max-width: 750px) {
  .SCXIIHF6ax3bOJ {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100vh - 164px);
    margin-top: var(--ds-space-500, 40px);
  }
}
.Shb3sGnl0xsW6J {
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  line-height: 24px;
}
.Vnl4IfLbQ8eyh4 {
  color: var(--ds-text-subtle, #44546f);
  font-size: 14px;
  line-height: 20px;
}
.KMGMZRBHo7NXCq {
  display: flex;
  flex-direction: column;
  height: 560px;
  margin: var(--ds-space-300, 24px) var(--ds-space-0, 0);
  padding: var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-radius-small, 4px);
  background: var(--ds-surface-raised, #ffffff);
}
.KMGMZRBHo7NXCq.GgtVdcxLfD4e1A {
  height: auto;
}
@media only screen and (max-width: 750px) {
  .KMGMZRBHo7NXCq {
    flex-basis: auto;
    flex-grow: 1;
    flex-shrink: 1;
    min-height: 170px;
    margin-bottom: var(--ds-space-150, 12px);
  }
}
.kZWqjkGhf5jvZC {
  padding: var(--ds-space-150, 12px);
}
.kZWqjkGhf5jvZC ._O7X970ovrrCsC {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: var(--ds-radius-small, 3px);
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  box-sizing: border-box;
  width: 100%;
  margin: var(--ds-space-0, 0);
}
.kZWqjkGhf5jvZC ._O7X970ovrrCsC:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.kZWqjkGhf5jvZC ._O7X970ovrrCsC:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.kZWqjkGhf5jvZC ._O7X970ovrrCsC:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.kZWqjkGhf5jvZC ._O7X970ovrrCsC[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.kZWqjkGhf5jvZC ._O7X970ovrrCsC.EbZFPBoZcN7btK {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.kZWqjkGhf5jvZC ._O7X970ovrrCsC.EbZFPBoZcN7btK:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.kZWqjkGhf5jvZC ._O7X970ovrrCsC.EbZFPBoZcN7btK:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.kZWqjkGhf5jvZC ._O7X970ovrrCsC.WwUPpgSBmGve6q {
  width: 100%;
}
.kZWqjkGhf5jvZC ._O7X970ovrrCsC::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.wlxL9TaTj8845V {
  height: 100%;
  overflow-y: auto;
}
.wJ6q1YtVoN8VV_ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.L2j_apGxhpiRdF {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.L2j_apGxhpiRdF .r5__BZeAZyBGxA {
  margin: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-300, 24px) var(--ds-space-150, 12px);
  color: var(--ds-text-subtle, #44546f);
}
@media only screen and (max-width: 750px) {
  .uEu14Pdoeys2tN button {
    width: 100%;
  }
}
@media only screen and (max-width: 750px) {
  .uEu14Pdoeys2tN {
    margin-bottom: var(--ds-space-075, 6px);
  }
}
`, ""]);
// Exports
export var container = `SCXIIHF6ax3bOJ`;
export var title = `Shb3sGnl0xsW6J`;
export var subText = `Vnl4IfLbQ8eyh4`;
export var listBoxContainer = `KMGMZRBHo7NXCq`;
export var responsive = `GgtVdcxLfD4e1A`;
export var searchInputContainer = `kZWqjkGhf5jvZC`;
export var searchInput = `_O7X970ovrrCsC`;
var _1 = `EbZFPBoZcN7btK`;
export { _1 as "input-error" };
export var full = `WwUPpgSBmGve6q`;
export var workspacesContainer = `wlxL9TaTj8845V`;
export var spinnerContainer = `wJ6q1YtVoN8VV_`;
export var noWorkspaceContainer = `L2j_apGxhpiRdF`;
export var noWorkspaceText = `r5__BZeAZyBGxA`;
export var upgradeButtonContainer = `uEu14Pdoeys2tN`;
export default ___CSS_LOADER_EXPORT___;
